import React from 'react';


type TabsProps<T extends string | number> = {
	options: {
		label: string,
		value: T,
		// Draw the label in the box of the Tag: rounded corners, a blue-50 fill, a 1 px ring.
		// The label keeps the colour of the tab state. The native select ignores the flag.
		outlined?: boolean
	}[],
	value: T,
	onChange: (value: T) => void

}

const Tabs = <T extends string | number,>({ options, value, onChange }: TabsProps<T>) => {

	const activeClassNames = 'whitespace-nowrap border-b-2 border-blue-500 px-3 py-1.5 text-sm font-medium text-blue-600 cursor-pointer';
	const inactiveClassNames = 'whitespace-nowrap border-b-2 border-transparent px-3 py-1.5 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer';
	const outlinedLabelClassNames = 'inline-flex items-center rounded-md bg-blue-50 px-2 py-0.5 ring-1 ring-inset ring-blue-700/10';

	const toSelectValue = (v: T) => String(v);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selected = options.find(o => toSelectValue(o.value) === e.target.value);
		if (selected) {
			onChange(selected.value);
		}
	};


	return <>
			<div className="grid grid-cols-1 sm:hidden">
				<select aria-label="Select a tab"
								value={toSelectValue(value)}
								onChange={handleSelectChange}
								className="col-start-1 row-start-1 w-full input">
					{options.map(o => <option key={o.label} id={o.label} value={toSelectValue(o.value)}>{o.label}</option>)}
				</select>
			</div>
			<div className="hidden sm:block">
				<div className="border-b border-gray-200">
					<nav className="-mb-px flex" aria-label="Tabs">
						{options.map(o => <button key={o.label} onClick={() => onChange(o.value)}
													className={(o.value === value) ? activeClassNames : inactiveClassNames}>
							{o.outlined === true ? <span className={outlinedLabelClassNames}>{o.label}</span> : o.label}
						</button>)}
					</nav>
				</div>
			</div>
	</>;
};

export default Tabs;